import { PageTypes } from "./catalog/types";

/**
 * Тип страницы для SSR-пропсов (`pageProps.pageType`) и для llms-md.
 * Строковые зоны сайта и числовой каталог (`PageTypes`) — в одном объекте, одни и те же значения, что в `detectPageType`.
 */
export const SITE_PAGE_TYPE = {
  home: "home",
  static: "static",
  catalogIndex: "catalog_index",
  newsList: "news_list",
  newsDetail: "news_detail",
  servicesList: "services_list",
  serviceDetail: "service_detail",
  brandsList: "brands_list",
  brandDetail: "brand_detail",
  shopsList: "shops_list",
  shopDetail: "shop_detail",
  contacts: "contacts",
  personal: "personal",
  searchResults: "search_results",

  notFound: PageTypes.notFound,
  filter: PageTypes.filter,
  product: PageTypes.product,
  section: PageTypes.section,
  sections: PageTypes.sections,
} as const;

export type SitePageType = (typeof SITE_PAGE_TYPE)[keyof typeof SITE_PAGE_TYPE];
